import React from "react";
import { Link } from "react-router-dom";

export default class FloatHeader extends React.Component {
  render() {
    return (
      <Link to={this.props.link || "/"} data-component="FloatHeader">
        <div className="nav-title no-print">
          <div className="nav-title-logo">
            <img src={"/logo40.png"} alt={"ElecTrek"} className={"shadow"} />
          </div>
        </div>
      </Link>
    );
  }
}
